import config, {layers} from "./config.tampere";

export {layers};

export default config;
